// Subscritores da newsletter — guardados em localStorage (ver lib/newsletter.js).
// Não envia para nenhuma plataforma externa ainda (ver Definições > Integrações).

export const initialSubscribers = [
  { id: "sub-1001", email: "rita.pereira@example.pt", source: "footer", subscribedAt: "2025-10-30T11:20:00" },
  { id: "sub-1002", email: "hugo.martins@example.pt", source: "bloco", subscribedAt: "2025-11-04T16:05:00" },
];
